import React, { Component } from 'react'
import FixedView from '../FixedView'
import IntractionActionsList from '../IntractionActionsList'
import Collapsible from 'react-collapsible'
import { translate } from '../../utils/useful'

export default class InqueriesFrame extends Component {
    state = {
        list: []

    }
    changeCollapsepage = () => {
        let page = this.state.page
        this.setState({ page: !page })
    }
    changeCollapsemanage = () => {
        let manage = this.state.manage
        this.setState({ manage: !manage })
    }
    render() {
        return (
            <div>
                <button onClick={() => this.framesOptionsList.showView()} ref={el => this.framesNode = el} className='flexc mrd-2'>
                    <div className='flexcc pld-3 prd-4 py-1 br-5 dark-blur-bg'>
                        <div className='flexcc mrd-1'>
                            <img className={this.props.invert ? 'invert' : ''} width={18} src="/assets/icons/applets/database/frame-white.svg" />
                        </div>
                        <p className='font-size-14 ' style={{ color: '#fff' }}>{this.props.currentFrame?.name ?? translate('inquiriesframe.Frames')}</p>
                    </div>
                </button>
                <FixedView width={this.props.width} zIndex={10} ref={el => this.framesOptionsList = el} nodeRef={this.framesNode} xOffset={-9} bottomOffset={27} topOffset={0} maxWidth={260} >
                    <div className='bg-white br-10 p-1 shadow-3  ' >
                        <div className='p-1 sc-gray2' style={{ maxHeight: '350px', overflowY: 'scroll' }}>
                            <div className=' mb-2'>
                                <IntractionActionsList language={this.props.language} data={{ title: "{{lang}}inquiriesframe.Pin Frames", icon: "/assets/icons/applets/database/pin-purple.svg" }} />
                            </div>
                            <div className='white-bg py-2 ' style={{ borderTop: '1px solid #eee', borderBottom: '1px solid #eee', }}>
                                <button className='flexcb p-2 w-100 hover-gray br-10' onClick={() => this.changeCollapsepage()} >
                                    <div className='flexc'>
                                        <img className='mrd-2 flexcc' width={18} src='/assets/icons/applets/database/stages-purple.svg' />
                                        <p className='main-c3'>{translate('inquiriesframe.Collections')}</p>
                                    </div>
                                    <button>
                                        <img width={22} className={'flexcc transition ' + (this.state.page ? 'rotate-180' : '')} src='/assets/icons/applets/database/arrow-up-purple.svg' />
                                    </button>
                                </button>
                                <Collapsible open={this.state.page} transitionTime={100}>
                                    <div className='py-2'>
                                        {/* <IntractionActionsList language={this.props.language} data={{ title: "{{lang}}inquiriesframe.Collection", icon: "/assets/icons/applets/database/pages-purple.svg" }} />
                                         */}
                                        <div className='mt-1 br-10' style={{ backgroundColor: '#F6F6F6', overflow: 'hidden' }}>
                                            <div className=''>
                                                <button style={{ borderBottom: '1px solid #eee' }} className='flexcb purple-btn py-2 px-2 w-100' onClick={() => this.props.addNewForm()} >
                                                    <p>Create New</p>
                                                    <p className='font-size-18'>+</p>
                                                </button>
                                            </div>
                                            {this.props.list?.map((prop, index) => {
                                                let name = 'form'
                                                return (
                                                    <div className='bb-gray pt-2'>
                                                        <button className={'flexcb p-2 w-100 hover-gray2'} style={{ backgroundColor: (prop._id == this.props.currentFrame?._id ? '#E0E0EB' : '') }} onClick={() => this.changeFrame(prop)} >
                                                            <div className=' flexc'>
                                                                {/* <img className='br-50 flexcc mrd-2' width={24} height={24} src={imageAddress('', "applet")} /> */}
                                                                <p className='text-left w-100' style={{ overflow: "hidden", whiteSpace: "nowrap", textOverflow: "ellipsis", }}>{prop.name}</p>
                                                            </div>
                                                            {prop._id == this.props.currentFrame?._id &&
                                                                <div className='flexcc'>
                                                                    <img width={18} src='/assets/icons/check-purple.svg' />
                                                                </div>
                                                            }
                                                        </button>
                                                    </div>
                                                )
                                            })}
                                        </div>
                                    </div>
                                </Collapsible>
                            </div>
                            <div className='white-bg py-2 ' style={{ borderBottom: '1px solid #eee', }}>
                                <button className='flexcb p-2 w-100 hover-gray br-10' onClick={() => this.changeCollapsemanage()} >
                                    <div className='flexc'>
                                        <img className='mrd-2 flexcc' width={18} src='/assets/icons/applets/database/stages-purple.svg' />
                                        <p className='main-c3'>{translate('inquiriesframe.Manage')}</p>
                                    </div>
                                    <button>
                                        <img width={22} className={'flexcc transition ' + (this.state.manage ? 'rotate-180' : '')} src='/assets/icons/applets/database/arrow-up-purple.svg' />
                                    </button>
                                </button>
                                <Collapsible open={this.state.manage} transitionTime={100}>
                                    <div className='py-2'>
                                        <IntractionActionsList language={this.props.language} data={{ title: "{{lang}}inquiriesframe.Providers", icon: "/images/icons/ad-center.png" }} />
                                        <IntractionActionsList language={this.props.language} data={{ title: "{{lang}}inquiriesframe.Reports", icon: "/images/icons/climate.png" }} />
                                        <IntractionActionsList language={this.props.language} data={{ title: "{{lang}}inquiriesframe.Providers", icon: "/images/icons/emotional.png" }} />
                                        <IntractionActionsList language={this.props.language} data={{ title: "{{lang}}inquiriesframe.Clients", icon: "/images/icons/events.png" }} />
                                    </div>
                                </Collapsible>
                            </div>
                            <IntractionActionsList language={this.props.language} data={{ title: "{{lang}}inquiriesframe.User Perspective", icon: "/assets/icons/applets/database/user.svg" }} />
                            <IntractionActionsList language={this.props.language} data={{ title: "{{lang}}inquiriesframe.Main View", icon: "/assets/icons/applets/database/user.svg" }} />
                        </div>
                    </div >
                </FixedView >
            </div >
        )
    }
}
